module.exports = __webpack_public_path__ + "img/c5.6b664519.png";